import orderBy from 'lodash/orderBy'

export type Order = 'asc' | 'desc'

export const sortTableRows = <T>(rows: readonly T[], order: Order, orderByKey: keyof T): T[] =>
  orderBy([...rows], [orderByKey as string], [order])
